import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ClientService } from '@shared/services/client.service';

@Component({
  selector: 'db-client-header-details',
  templateUrl: './client-header-details.component.html'
})
export class ClientHeaderDetailsComponent implements OnInit {
  @Input() data: any;
  folderUrl: SafeUrl;


  constructor(private _clientService: ClientService, private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.createClientFolder();
  }

  createClientFolder() {
      this._clientService.createClientFolder(this.data.clientId).subscribe(
        ((response: string) => {
          const cleanUrl = response.replace(/^"+|"+$/g, '');
          this.folderUrl = this.sanitizer.bypassSecurityTrustUrl(cleanUrl);
        })
      );
  }
}
